// Aviso local (en este navegador) de que el paciente ha enviado un formulario.
// La tarjeta del home y la barra lateral abren el mismo modal: la que no lo
// abrió se entera por aquí y se actualiza sin recargar.
// Evento: { type: "weekly", state } — `state` es la respuesta de /me/weekly-form.
// Los mensuales solo se abren desde la barra lateral: { type: "sus" }.
const listeners = new Set();

export const emitFormSaved = (event) => listeners.forEach((listener) => listener(event));

// Devuelve la función para darse de baja (se puede retornar tal cual desde useEffect).
export const onFormSaved = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
